// extracted by mini-css-extract-plugin
export default {"container":"FloatingButtons_container__AtrlJ","buttonIcon":"FloatingButtons_buttonIcon__TYEuN"};